import React from 'react';
import s from '../styles/Pager.module.scss';

export default function Pager({ page = 1, pages = 1, onPrev, onNext }) {
    if (pages <= 1) return null;

    return (
        <div className={s.pager}>
            <button
                type="button"
                className={s.btnLight}
                disabled={page <= 1}
                onClick={onPrev}
            >
                « Назад
            </button>

            <span className={s.pager__info}>
                {page} / {pages}
            </span>

            <button
                type="button"
                className={s.btnLight}
                disabled={page >= pages}
                onClick={onNext}
            >
                Далі »
            </button>
        </div>
    );
}
